import { IResult } from '@sv-support-sdk/shared-types/src/common/search';
import linkifyHtml from 'linkify-html';
import sanitize from 'sanitize-html';

export const mapResultList = (list: IResult[]) => list.map((result: IResult) => {
  const isTicketType = result.type === 'ticket';
  const description = isTicketType ? result.title : result.description || result.answer;
  const title = isTicketType ? result.id : result.title || result.name || result.question;

  return {
    ...result,
    description: linkifyHtml(
      sanitize(description || '', {
        allowedTags: ['a'],
        allowedAttributes: {
          a: ['href', 'target'],
        },
      }),
      { target: '_blank' },
    ),
    title,
  };
});
